import { SVGProps } from 'react';

interface SizeIconProps extends SVGProps<SVGSVGElement> {
    size?: number;
}

export function SizeIcon({ size = 24, ...props }: SizeIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="hsla(0, 0%, 0%, 0.6)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <circle cx="14" cy="12" r="9" />
            <circle cx="6" cy="12" r="5" />
        </svg>
    );
}
